import { local_admin_users_online_upsert } from '@/state/_admin/admin_users/local_admin_users_online_upsert';
import { store } from '@/state/store';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../_methods/add_socket_handler_client';

export function add_socket_handlers_client_admin() {
  add(ENE.ADMIN_USERS_ONLINE_UPSERT, (value: number) => store.dispatch(local_admin_users_online_upsert(value)));
}
